<template lang="html">

  <div :style="fretStyle"
       v-bind:class="computeFretClass"
       @click="onFretClick"
       @mouseover="mouseHover = true"
       @mouseleave="mouseHover = false">

    <transition name="fade">
    <span v-show="item.show===true" class="note" v-bind:class="computeNoteClass">
        <span v-if="showTones===true">{{ item.tone }}</span>
      <span v-else>{{ item.note }} </span>
    </span>
    </transition>


  </div>
</template>

<script>


export default {
  components: {}, props: {
    fretStyle: String, myString: Number, myFret: Number, item: Object, showTones: Boolean, fretboardClass: String, fretClass: String,

    belongToLayer: {
      type: Boolean, default: false
    }
  },

  data() {
    return {
      mouseHover: false
    }
  },

  computed: {
    computeFretClass() {
      /* tasto verticale o orizzontale */
      let styles = [this.fretClass];

      if (this.mouseHover) {
        styles.push("isHovering");
      }
      return styles.join(' ');
    },


    computeNoteClass() {

      if (this.item.isPlay === true) {
        return 'fretIsPlaying';
      }

      if (this.belongToLayer===true){
        return 'noteLayer'
      }
      return this.item.noteClass;
    }
  },

  methods: {


    onFretClick() {
      /* f: 0 - 24
        s: 0-5 (0 highest string, 5 lowest string)
       */
      this.$parent.$emit('fretClick', {'string': this.myString, 'fret': this.myFret});
    }


  }
}
</script>

<style>
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}

</style>
